import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosCiviles from "../vistas/vista_datos_civiles";
import FormDatosCiviles from "../formularios/form_datos_civiles";

export default class DesplegableDatosCiviles extends Component {
  render() {
    return (
      <Desplegable
        eventKey="1"
        id="1"
        Toogle="Datos Civiles"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalArray[1]}
        Text={<VistaDatosCiviles DatosProvincia={this.props.state.DatosProvincia}></VistaDatosCiviles>}
        Form={
          <FormDatosCiviles
            DatosProvincia={this.props.state.DatosProvincia}
            setInformacionOrganismo={this.props.setInformacionOrganismo}
            handleButtonShow={this.props.handleButtonShow}
            nullField={this.props.nullField}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormDatosCiviles>
        }
        canEdit={true}
      />
    );
  }
}
